var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"fold-button",class:[_vm.buttonClass],attrs:{"title":(_vm.fold ? '展开' : '折叠') + _vm.name},on:{"click":function($event){return _vm.$emit('update:fold', !_vm.fold)}}},[_c('i',{class:[_vm.iconClass]})])}
var staticRenderFns = []

export { render, staticRenderFns }